/**
 * Pawsy: sticky Add to Cart for the three product pages.
 *
 * This deliberately owns no cart logic. The buy box already resolves the
 * variant, quantity and selling plan for the selected tier and handles the
 * drawer, so the sticky button forwards a click to the real .pw-atc button
 * rather than calling /cart/add.js a second time. One code path, so the two
 * buttons can never disagree.
 *
 * Price stays in sync by observing the real button's [data-atc-total] span
 * instead of recomputing it, for the same reason.
 *
 * The theme ships an older <pdp-sticky-cta> ("Try Pawsy") that is hidden by
 * the footer snippet and whose custom element was never ported. This replaces
 * it; that markup is left alone and stays hidden.
 */
(function () {
  if (window.__pawsyStickyAtc) return;
  window.__pawsyStickyAtc = true;

  function init() {
    var atc = document.querySelector('.pw-atc');
    if (!atc || document.querySelector('.pawsy-satc')) return;

    var totalEl = document.querySelector('[data-atc-total]');
    var h1 = document.querySelector('h1');
    var name = h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : 'Pawsy';

    // og:image is the product's featured image, so it is the packshot rather
    // than whichever lifestyle photo happens to lead the gallery. Fall back to
    // the gallery, then to no thumb at all rather than a broken frame.
    var src = '';
    var og = document.querySelector('meta[property="og:image"]');
    if (og && og.content) src = og.content;
    if (!src) {
      var img = document.querySelector('.pw-tier__thumb img, .product__media img, .product-media img');
      if (img) src = img.currentSrc || img.src || '';
    }

    var bar = document.createElement('div');
    bar.className = 'pawsy-satc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="pawsy-satc__inner">' +
        (src ? '<img class="pawsy-satc__thumb" src="' + src + '" alt="" width="44" height="44">' : '') +
        '<div class="pawsy-satc__meta">' +
          '<span class="pawsy-satc__name"></span>' +
          '<span class="pawsy-satc__sub">Free shipping over $75</span>' +
        '</div>' +
        '<button type="button" class="pawsy-satc__btn">ADD TO CART<span class="pawsy-satc__price"></span></button>' +
      '</div>';
    bar.querySelector('.pawsy-satc__name').textContent = name;
    document.body.appendChild(bar);

    var priceEl = bar.querySelector('.pawsy-satc__price');
    var btn = bar.querySelector('.pawsy-satc__btn');

    function syncPrice() {
      var t = totalEl ? totalEl.textContent.trim() : '';
      priceEl.textContent = t ? ' — ' + t : '';
    }
    syncPrice();
    if (totalEl && window.MutationObserver) {
      new MutationObserver(syncPrice).observe(totalEl, { childList: true, characterData: true, subtree: true });
    }

    // Forward to the real button so there is exactly one cart code path.
    btn.addEventListener('click', function () {
      btn.disabled = true;
      atc.click();
      setTimeout(function () { btn.disabled = false; }, 900);
    });

    var drawerOpen = false, past = false;
    function apply() {
      var show = past && !drawerOpen;
      bar.classList.toggle('pawsy-satc--on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    // Show only once the real button has scrolled ABOVE the viewport, so it
    // never doubles up with the buy box the user is already looking at.
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        past = !e.isIntersecting && e.boundingClientRect.top < 0;
        apply();
      }, { threshold: 0 }).observe(atc);
    }

    // The cart drawer sits above this bar; hide rather than stack under it.
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () {
        drawerOpen = drawer.classList.contains('active');
        apply();
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
